import { launchPrivider } from 'services/launch';

export const typeFreezing = async () => {
  const { data } = await launchPrivider.getTypeFreezing();

  return data;
};
